/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type McpAuthorizationServerMetadataResponse,
    McpAuthorizationServerMetadataResponseFromJSON,
    McpAuthorizationServerMetadataResponseToJSON,
} from '../models/McpAuthorizationServerMetadataResponse';
import {
    type McpConsentDetailResponse,
    McpConsentDetailResponseFromJSON,
    McpConsentDetailResponseToJSON,
} from '../models/McpConsentDetailResponse';
import {
    type McpConsentRedirectResponse,
    McpConsentRedirectResponseFromJSON,
    McpConsentRedirectResponseToJSON,
} from '../models/McpConsentRedirectResponse';
import {
    type McpDynamicClientRegistrationErrorResponse,
    McpDynamicClientRegistrationErrorResponseFromJSON,
    McpDynamicClientRegistrationErrorResponseToJSON,
} from '../models/McpDynamicClientRegistrationErrorResponse';
import {
    type McpDynamicClientRegistrationRequest,
    McpDynamicClientRegistrationRequestFromJSON,
    McpDynamicClientRegistrationRequestToJSON,
} from '../models/McpDynamicClientRegistrationRequest';
import {
    type McpDynamicClientRegistrationResponse,
    McpDynamicClientRegistrationResponseFromJSON,
    McpDynamicClientRegistrationResponseToJSON,
} from '../models/McpDynamicClientRegistrationResponse';
import {
    type McpGrantResponse,
    McpGrantResponseFromJSON,
    McpGrantResponseToJSON,
} from '../models/McpGrantResponse';
import {
    type McpOAuthErrorResponse,
    McpOAuthErrorResponseFromJSON,
    McpOAuthErrorResponseToJSON,
} from '../models/McpOAuthErrorResponse';
import {
    type McpOAuthTokenResponse,
    McpOAuthTokenResponseFromJSON,
    McpOAuthTokenResponseToJSON,
} from '../models/McpOAuthTokenResponse';
import {
    type McpProtectedResourceMetadataResponse,
    McpProtectedResourceMetadataResponseFromJSON,
    McpProtectedResourceMetadataResponseToJSON,
} from '../models/McpProtectedResourceMetadataResponse';

export interface MCPOAuthApiApproveMCPAuthorizationRequestRequest {
    handle: string;
    body: object;
}

export interface MCPOAuthApiDenyMCPAuthorizationRequestRequest {
    handle: string;
    body: object;
}

export interface MCPOAuthApiMCPAuthorizationRequestDetailRequest {
    handle: string;
}

export interface MCPOAuthApiMCPOAuthAuthorizationRequest {
    responseType: MCPOAuthAuthorizationResponseTypeEnum;
    clientId: string;
    redirectUri: string;
    state: string;
    resource: string;
    scope: MCPOAuthAuthorizationScopeEnum;
    codeChallenge: string;
    codeChallengeMethod: MCPOAuthAuthorizationCodeChallengeMethodEnum;
}

export interface MCPOAuthApiMCPOAuthDynamicClientRegistrationRequest {
    mcpDynamicClientRegistrationRequest: McpDynamicClientRegistrationRequest;
}

export interface MCPOAuthApiMCPOAuthRevocationRequest {
    token: string;
    clientId: string;
    tokenTypeHint?: MCPOAuthRevocationTokenTypeHintEnum;
}

export interface MCPOAuthApiMCPOAuthTokenRequest {
    grantType?: MCPOAuthTokenGrantTypeEnum;
    clientId?: string;
    code?: string;
    redirectUri?: string;
    codeVerifier?: string;
    resource?: string;
    refreshToken?: string;
}

export interface MCPOAuthApiRevokeAccountMCPGrantRequest {
    grantId: string;
}

/**
 * 
 */
export class MCPOAuthApi extends runtime.BaseAPI {

    /**
     * Creates request options for approveMCPAuthorizationRequest without sending the request
     */
    async approveMCPAuthorizationRequestRequestOpts(requestParameters: MCPOAuthApiApproveMCPAuthorizationRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['handle'] == null) {
            throw new runtime.RequiredError(
                'handle',
                'Required parameter "handle" was null or undefined when calling approveMCPAuthorizationRequest().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling approveMCPAuthorizationRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/mcp/authorization-requests/{handle}/approve`;
        urlPath = urlPath.replace('{handle}', encodeURIComponent(String(requestParameters['handle'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     */
    async approveMCPAuthorizationRequestRaw(requestParameters: MCPOAuthApiApproveMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpConsentRedirectResponse>> {
        const requestOptions = await this.approveMCPAuthorizationRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpConsentRedirectResponseFromJSON(jsonValue));
    }

    /**
     */
    async approveMCPAuthorizationRequest(requestParameters: MCPOAuthApiApproveMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpConsentRedirectResponse> {
        const response = await this.approveMCPAuthorizationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for denyMCPAuthorizationRequest without sending the request
     */
    async denyMCPAuthorizationRequestRequestOpts(requestParameters: MCPOAuthApiDenyMCPAuthorizationRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['handle'] == null) {
            throw new runtime.RequiredError(
                'handle',
                'Required parameter "handle" was null or undefined when calling denyMCPAuthorizationRequest().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling denyMCPAuthorizationRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/mcp/authorization-requests/{handle}/deny`;
        urlPath = urlPath.replace('{handle}', encodeURIComponent(String(requestParameters['handle'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     */
    async denyMCPAuthorizationRequestRaw(requestParameters: MCPOAuthApiDenyMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpConsentRedirectResponse>> {
        const requestOptions = await this.denyMCPAuthorizationRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpConsentRedirectResponseFromJSON(jsonValue));
    }

    /**
     */
    async denyMCPAuthorizationRequest(requestParameters: MCPOAuthApiDenyMCPAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpConsentRedirectResponse> {
        const response = await this.denyMCPAuthorizationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAccountMCPGrants without sending the request
     */
    async listAccountMCPGrantsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/mcp/grants`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listAccountMCPGrantsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<McpGrantResponse>>> {
        const requestOptions = await this.listAccountMCPGrantsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(McpGrantResponseFromJSON));
    }

    /**
     */
    async listAccountMCPGrants(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<McpGrantResponse>> {
        const response = await this.listAccountMCPGrantsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPAuthorizationRequestDetail without sending the request
     */
    async mCPAuthorizationRequestDetailRequestOpts(requestParameters: MCPOAuthApiMCPAuthorizationRequestDetailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['handle'] == null) {
            throw new runtime.RequiredError(
                'handle',
                'Required parameter "handle" was null or undefined when calling mCPAuthorizationRequestDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/mcp/authorization-requests/{handle}`;
        urlPath = urlPath.replace('{handle}', encodeURIComponent(String(requestParameters['handle'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPAuthorizationRequestDetailRaw(requestParameters: MCPOAuthApiMCPAuthorizationRequestDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpConsentDetailResponse>> {
        const requestOptions = await this.mCPAuthorizationRequestDetailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpConsentDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPAuthorizationRequestDetail(requestParameters: MCPOAuthApiMCPAuthorizationRequestDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpConsentDetailResponse> {
        const response = await this.mCPAuthorizationRequestDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPOAuthAuthorization without sending the request
     */
    async mCPOAuthAuthorizationRequestOpts(requestParameters: MCPOAuthApiMCPOAuthAuthorizationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['responseType'] == null) {
            throw new runtime.RequiredError(
                'responseType',
                'Required parameter "responseType" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['redirectUri'] == null) {
            throw new runtime.RequiredError(
                'redirectUri',
                'Required parameter "redirectUri" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError(
                'state',
                'Required parameter "state" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['resource'] == null) {
            throw new runtime.RequiredError(
                'resource',
                'Required parameter "resource" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['scope'] == null) {
            throw new runtime.RequiredError(
                'scope',
                'Required parameter "scope" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['codeChallenge'] == null) {
            throw new runtime.RequiredError(
                'codeChallenge',
                'Required parameter "codeChallenge" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        if (requestParameters['codeChallengeMethod'] == null) {
            throw new runtime.RequiredError(
                'codeChallengeMethod',
                'Required parameter "codeChallengeMethod" was null or undefined when calling mCPOAuthAuthorization().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['responseType'] != null) {
            queryParameters['response_type'] = requestParameters['responseType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['redirectUri'] != null) {
            queryParameters['redirect_uri'] = requestParameters['redirectUri'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['resource'] != null) {
            queryParameters['resource'] = requestParameters['resource'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['codeChallenge'] != null) {
            queryParameters['code_challenge'] = requestParameters['codeChallenge'];
        }

        if (requestParameters['codeChallengeMethod'] != null) {
            queryParameters['code_challenge_method'] = requestParameters['codeChallengeMethod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/oauth/authorize`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPOAuthAuthorizationRaw(requestParameters: MCPOAuthApiMCPOAuthAuthorizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.mCPOAuthAuthorizationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mCPOAuthAuthorization(requestParameters: MCPOAuthApiMCPOAuthAuthorizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mCPOAuthAuthorizationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for mCPOAuthAuthorizationServerMetadata without sending the request
     */
    async mCPOAuthAuthorizationServerMetadataRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/.well-known/oauth-authorization-server`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPOAuthAuthorizationServerMetadataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpAuthorizationServerMetadataResponse>> {
        const requestOptions = await this.mCPOAuthAuthorizationServerMetadataRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpAuthorizationServerMetadataResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPOAuthAuthorizationServerMetadata(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpAuthorizationServerMetadataResponse> {
        const response = await this.mCPOAuthAuthorizationServerMetadataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPOAuthDynamicClientRegistration without sending the request
     */
    async mCPOAuthDynamicClientRegistrationRequestOpts(requestParameters: MCPOAuthApiMCPOAuthDynamicClientRegistrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['mcpDynamicClientRegistrationRequest'] == null) {
            throw new runtime.RequiredError(
                'mcpDynamicClientRegistrationRequest',
                'Required parameter "mcpDynamicClientRegistrationRequest" was null or undefined when calling mCPOAuthDynamicClientRegistration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/oauth/register`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: McpDynamicClientRegistrationRequestToJSON(requestParameters['mcpDynamicClientRegistrationRequest']),
        };
    }

    /**
     */
    async mCPOAuthDynamicClientRegistrationRaw(requestParameters: MCPOAuthApiMCPOAuthDynamicClientRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpDynamicClientRegistrationResponse>> {
        const requestOptions = await this.mCPOAuthDynamicClientRegistrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpDynamicClientRegistrationResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPOAuthDynamicClientRegistration(requestParameters: MCPOAuthApiMCPOAuthDynamicClientRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpDynamicClientRegistrationResponse> {
        const response = await this.mCPOAuthDynamicClientRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPOAuthRevocation without sending the request
     */
    async mCPOAuthRevocationRequestOpts(requestParameters: MCPOAuthApiMCPOAuthRevocationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling mCPOAuthRevocation().'
            );
        }

        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling mCPOAuthRevocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['token'] != null) {
            formParams.append('token', requestParameters['token'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append('client_id', requestParameters['clientId'] as any);
        }

        if (requestParameters['tokenTypeHint'] != null) {
            formParams.append('token_type_hint', requestParameters['tokenTypeHint'] as any);
        }


        let urlPath = `/oauth/revoke`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     */
    async mCPOAuthRevocationRaw(requestParameters: MCPOAuthApiMCPOAuthRevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.mCPOAuthRevocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mCPOAuthRevocation(requestParameters: MCPOAuthApiMCPOAuthRevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.mCPOAuthRevocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPOAuthToken without sending the request
     */
    async mCPOAuthTokenRequestOpts(requestParameters: MCPOAuthApiMCPOAuthTokenRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['grantType'] != null) {
            formParams.append('grant_type', requestParameters['grantType'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append('client_id', requestParameters['clientId'] as any);
        }

        if (requestParameters['code'] != null) {
            formParams.append('code', requestParameters['code'] as any);
        }

        if (requestParameters['redirectUri'] != null) {
            formParams.append('redirect_uri', requestParameters['redirectUri'] as any);
        }

        if (requestParameters['codeVerifier'] != null) {
            formParams.append('code_verifier', requestParameters['codeVerifier'] as any);
        }

        if (requestParameters['resource'] != null) {
            formParams.append('resource', requestParameters['resource'] as any);
        }

        if (requestParameters['refreshToken'] != null) {
            formParams.append('refresh_token', requestParameters['refreshToken'] as any);
        }


        let urlPath = `/oauth/token`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     */
    async mCPOAuthTokenRaw(requestParameters: MCPOAuthApiMCPOAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpOAuthTokenResponse>> {
        const requestOptions = await this.mCPOAuthTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpOAuthTokenResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPOAuthToken(requestParameters: MCPOAuthApiMCPOAuthTokenRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpOAuthTokenResponse> {
        const response = await this.mCPOAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mCPProtectedResourceMetadata without sending the request
     */
    async mCPProtectedResourceMetadataRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/.well-known/oauth-protected-resource/mcp`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mCPProtectedResourceMetadataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McpProtectedResourceMetadataResponse>> {
        const requestOptions = await this.mCPProtectedResourceMetadataRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McpProtectedResourceMetadataResponseFromJSON(jsonValue));
    }

    /**
     */
    async mCPProtectedResourceMetadata(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McpProtectedResourceMetadataResponse> {
        const response = await this.mCPProtectedResourceMetadataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revokeAccountMCPGrant without sending the request
     */
    async revokeAccountMCPGrantRequestOpts(requestParameters: MCPOAuthApiRevokeAccountMCPGrantRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['grantId'] == null) {
            throw new runtime.RequiredError(
                'grantId',
                'Required parameter "grantId" was null or undefined when calling revokeAccountMCPGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/mcp/grants/{grantId}`;
        urlPath = urlPath.replace('{grantId}', encodeURIComponent(String(requestParameters['grantId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async revokeAccountMCPGrantRaw(requestParameters: MCPOAuthApiRevokeAccountMCPGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.revokeAccountMCPGrantRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async revokeAccountMCPGrant(requestParameters: MCPOAuthApiRevokeAccountMCPGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeAccountMCPGrantRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const MCPOAuthAuthorizationResponseTypeEnum = {
    Code: 'code'
} as const;
export type MCPOAuthAuthorizationResponseTypeEnum = typeof MCPOAuthAuthorizationResponseTypeEnum[keyof typeof MCPOAuthAuthorizationResponseTypeEnum];
/**
 * @export
 */
export const MCPOAuthAuthorizationScopeEnum = {
    McpRead: 'mcp:read'
} as const;
export type MCPOAuthAuthorizationScopeEnum = typeof MCPOAuthAuthorizationScopeEnum[keyof typeof MCPOAuthAuthorizationScopeEnum];
/**
 * @export
 */
export const MCPOAuthAuthorizationCodeChallengeMethodEnum = {
    S256: 'S256'
} as const;
export type MCPOAuthAuthorizationCodeChallengeMethodEnum = typeof MCPOAuthAuthorizationCodeChallengeMethodEnum[keyof typeof MCPOAuthAuthorizationCodeChallengeMethodEnum];
/**
 * @export
 */
export const MCPOAuthRevocationTokenTypeHintEnum = {
    AccessToken: 'access_token',
    RefreshToken: 'refresh_token'
} as const;
export type MCPOAuthRevocationTokenTypeHintEnum = typeof MCPOAuthRevocationTokenTypeHintEnum[keyof typeof MCPOAuthRevocationTokenTypeHintEnum];
/**
 * @export
 */
export const MCPOAuthTokenGrantTypeEnum = {
    RefreshToken: 'refresh_token'
} as const;
export type MCPOAuthTokenGrantTypeEnum = typeof MCPOAuthTokenGrantTypeEnum[keyof typeof MCPOAuthTokenGrantTypeEnum];
